import { useEffect, useState } from "react";
import { Card } from "react-bootstrap"
// import { CandlestickChart } from ".";
import './style.css';
import { getLiveNewsSentiment } from "../../../api/otherEndPoints/nifty50SpotCharts";
import { sentimentMaker } from "../../../services/util/newsSentiment";
import { RxCross2 } from "react-icons/rx";
import Amcharts from "../Amcharts";
let selectedSentimentType: any = 'updated';

interface CandlestickChartProps {
    selectedDate: any,
    setViewNIFTYCharts:any
}

const ChartComponent: React.FC<CandlestickChartProps> = ({ selectedDate,setViewNIFTYCharts }: any) => {
    const [sentimentType, setSentimentType] = useState<any>(selectedSentimentType)
    const [intervalId, setIntervalId] = useState<any>(null); // State variable to store the interval ID
    const [accuracy, setAccuracy] = useState<any>({})
    const [newsSignals, setNewsSignals] = useState<any>({})
    const [totalPL, setTotalPL] = useState<any>({})
    const [newsSentimentResponse, setNewsSentimentResponse] = useState<any>({})
    const [stockName, setStockName] = useState<any>('NIFTY 50')

    selectedSentimentType  = sentimentType;
    useEffect(() => {
        handleDateSelection(selectedDate);
        return () => {
            stopInterval();
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selectedDate]);

    useEffect(()=>{
        if((newsSignals!=null) && (newsSignals?.length > 0)){
            let toggleID:any = document.getElementById('switch-rounded')
            if(toggleID !=null){
                if(sentimentType=='updated'){
                    toggleID.checked = true;
                }else{
                    toggleID.checked = false;
                }
            }
        }
    },[newsSignals])
    async function toggleSentiments() {
        let sentimentResponse: any = await sentimentMaker(newsSentimentResponse, selectedDate, selectedSentimentType)
        setAccuracy(sentimentResponse?.news_sentiment?.j_accuracy)
        setTotalPL(sentimentResponse?.news_sentiment?.j_pl)
        setNewsSignals(sentimentResponse?.news_sentiment.signal_data)
    }

    useEffect(() => {

        if (Object.keys(newsSentimentResponse).length > 0) {
            toggleSentiments();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [sentimentType])

    useEffect(() => {

        getNewsSentiment()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selectedDate])

    const getNewsSentiment = async () => {
        try {
            await getLiveNewsSentiment(selectedDate)
                .then(async (res: any) => {
                    if (!res.error) {
                        if (res !== null) {
                            if (Object.keys(res?.news_sentiment).length > 0) {
                                setNewsSentimentResponse(res)
                                let sentimentResponse: any = await sentimentMaker(res, selectedDate, selectedSentimentType)
                                if (Object.keys(sentimentResponse?.news_sentiment).length > 0) {
                                    setAccuracy(sentimentResponse?.news_sentiment?.j_accuracy)
                                    setTotalPL(sentimentResponse?.news_sentiment?.j_pl)
                                    setNewsSignals(sentimentResponse?.news_sentiment.signal_data)
                                }
                            }
                            else {
                                setNewsSignals([])
                                setAccuracy({})
                                setTotalPL({})
                            }
                        }
                    }
                }).catch((e) => {
                    console.log(e);
                })
        } catch (e) {
            console.log(e);
        }
    }

    // Function to start the interval
    function startInterval() {
        if (!intervalId) {
            const id: any = setInterval(() => {
                getNewsSentiment()
            }, 60000); // Execute every 1 second
            setIntervalId(id); // Update intervalId state variable
        }
    }

    // Function to stop the interval
    function stopInterval() {
        clearInterval(intervalId);
        setIntervalId(null); // Reset intervalId state variable
    }

    function handleDateSelection(selectedDate: any) {
        const today = new Date().toISOString().split('T')[0];
        if (selectedDate === today) {
            startInterval();
        } else {
            stopInterval();
        }
    }


    return (
        <div className="Nifty50_spotDiv" style={{width:"99.6vw", marginBottom:"-2rem"}}>
        <Card className="charts-card">

            <div className='chartMainDiv' >
                <div style={{ width: "100%", display: "flex", justifyContent: "flex-end", alignItems: "center" }}>
                    <div className="view_charts_row_closeBtn" >
                        <span onClick={() => { setViewNIFTYCharts(false) }}><RxCross2 /></span>
                    </div>
                </div>
                <div>
                    <div className='text_title'>
                        <p className="sentimentTitle">Live Sentiments<span>(NIFTY 50 Spot)</span></p>
                        {(newsSignals?.length > 0) ? <div className='toggleDiv'>
                            <span id='sentimentBtnText'>Show reversed signals</span>
                            <span className="switch">
                                <input id="switch-rounded" type="checkbox" onChange={(e: any) => {
                                    if (e.target.checked) {
                                        setSentimentType('updated')
                                    } else {
                                        setSentimentType('continuous')
                                    }
                                }} />
                                <label htmlFor="switch-rounded"></label>
                            </span>
                        </div> : ''}
                    </div>
                    {(Object.keys(accuracy)?.length > 0) && <div className='accuracyMainDiv'>
                        {true && <div className='sentimentScore accuracyTableMain' >
                            <table className="accuracyTable" >
                                <thead>
                                    <tr className='Trow' style={{ borderBottom: "1px solid rgba(128, 128, 128, 0.51)", width: "16.6%" }}>
                                        <th className='Thead'>Time (in mins)</th>
                                        <td style={{ borderRight: "1px solid rgba(128, 128, 128, 0.51)" }}>Total Signals</td>
                                        <td style={{ borderRight: "1px solid rgba(128, 128, 128, 0.51)" }}>3</td>
                                        <td style={{ borderRight: "1px solid rgba(128, 128, 128, 0.51)" }}>6</td>
                                        <td style={{ borderRight: "1px solid rgba(128, 128, 128, 0.51)" }}>9</td>
                                        <td style={{ borderRight: "1px solid rgba(128, 128, 128, 0.51)" }}>12</td>
                                        <td style={{ borderRight: "1px solid rgba(128, 128, 128, 0.51)" }}>15</td>
                                    </tr>
                                </thead>
                                <thead>
                                    <tr className='Trow' >
                                        <th className='Thead'>Accuracy (Only for reversed signals)</th>
                                        <td style={{ borderRight: "1px solid rgba(128, 128, 128, 0.51)" }}>{accuracy?.Total_Signals !== undefined ? (accuracy?.Total_Signals) : ''}</td>
                                        <td style={{ borderRight: "1px solid rgba(128, 128, 128, 0.51)" }}>{(accuracy['3'] !== undefined && accuracy['3'] !== null) ? `${accuracy['3']}%` : ''}</td>
                                        <td style={{ borderRight: "1px solid rgba(128, 128, 128, 0.51)" }}>{(accuracy['6'] !== undefined && accuracy['6'] !== null) ? `${accuracy['6']}%` : ''}</td>
                                        <td style={{ borderRight: "1px solid rgba(128, 128, 128, 0.51)" }}>{(accuracy['9'] !== undefined && accuracy['9'] !== null) ? `${accuracy['9']}%` : ''}</td>
                                        <td style={{ borderRight: "1px solid rgba(128, 128, 128, 0.51)" }}>{(accuracy['12'] !== undefined && accuracy['12'] !== null) ? `${accuracy['12']}%` : ''}</td>
                                        <td style={{ borderRight: "1px solid rgba(128, 128, 128, 0.51)" }}>{(accuracy['15'] !== undefined && accuracy['15'] !== null) ? `${accuracy['15']}%` : ''}</td>
                                    </tr>
                                    {(Object.keys(totalPL)?.length > 0) && <tr className='Trow'>
                                        <th className='Thead'>PL</th>
                                        <td style={{ borderRight: "1px solid rgba(128, 128, 128, 0.51)" }}>{accuracy?.Total_Signals !== undefined ? (accuracy?.Total_Signals) : ''}</td>
                                        <td style={{ borderRight: "1px solid rgba(128, 128, 128, 0.51)" }}>{(totalPL['3'] !== undefined && totalPL['3'] !== null) ? totalPL['3'] : ''}</td>
                                        <td style={{ borderRight: "1px solid rgba(128, 128, 128, 0.51)" }}>{(totalPL['6'] !== undefined && totalPL['6'] !== null) ? totalPL['6'] : ''}</td>
                                        <td style={{ borderRight: "1px solid rgba(128, 128, 128, 0.51)" }}>{(totalPL['9'] !== undefined && totalPL['9'] !== null) ? totalPL['9'] : ''}</td>
                                        <td style={{ borderRight: "1px solid rgba(128, 128, 128, 0.51)" }}>{(totalPL['12'] !== undefined && totalPL['12'] !== null) ? totalPL['12'] : ''}</td>
                                        <td style={{ borderRight: "1px solid rgba(128, 128, 128, 0.51)" }}>{(totalPL['15'] !== undefined && totalPL['15'] !== null) ? totalPL['15'] : ''}</td>
                                    </tr>}
                                </thead>
                            </table>
                        </div>}
                    </div>}
                    <div >
                    {((Object.keys(newsSignals))?.length) > 0 ? <Amcharts  data={newsSignals} selectedStock = {stockName} selectedDate={selectedDate}/>:                        <div className="noSignals">
                            <p>No Sentiment Signals Found</p>
                        </div>}
                    </div>
                </div>

            </div>
        </Card>
        </div>
    )
}

export default ChartComponent; 

